import recallServices from '../../../../../services/supplier/supplier-recall'
import { OUTPUT_DATE_FORMAT, PAPER_RESPONSE_TYPE, PAPER_RESPONSE_STATUS } from '../../../../../misc/commons'
import PaperModal from './paper-modal'
import ViewModal from '../../../../../components/part/shared/PreviewViewModal'
import PaperResponseImport from './paper-response-import'
import UpdateOptionModal from './update-option-modal'
import {Provider_Response_Headers} from '../../../../../misc/tableHeaders'
import HeaderCheckBox from '../../../../../components/noti/TableGrid/CustomComponent/headerCheckBox.vue'
import _ from 'lodash'

export default {
    props: {
        communicationId: {type: String, default: null},
        allow_paperresponse: {type: Boolean, default: true},
        status: {type: String, default: null},
        communicationType: {type: String, default: ''},
        communicationUID: {type: String, default: ''},
    },
    components: {
        PaperModal,
        ViewModal,
        PaperResponseImport,
        UpdateOptionModal,
        HeaderCheckBox
    },
    data() {
        return {
            OUTPUT_DATE_FORMAT: OUTPUT_DATE_FORMAT,
            globalSearchText: '',
            total: 0,
            items: [],
            paperModalKey: 0,
            viewModalKey: 0,
            paperResponseImportKey: 0,
            showUpdateResponseTypeButton: true,
            showUpdateStatusButton: true,
            canUpdateResponseActions: false,
            updateOptionModalKey: 0,
            selectedUpdateType: '',
            selectedUpdateValue: '',
            modalId: 'updateOptionModal',
            modalTitle: '',
            modalLabel: '',
            modalOptions: [],
            modalRadioName: 'updateOption',
            modalSelectedRowStatuses: [],
            showaddmore: true,
            disableRecallPRTemplateBtn: false,
            search: {
                responseStatus: null,
                affectedProduct: null,
                respondent: null,
                supplierOrgId: null,
                supplierOrgName: null,
                status: null,
                idn: null,
                location_id: null,
                location_name: null,
                address_1: null,
                address_2: null,
                city: null,
                state: null,
                postal_code: null,
                country: null,
                response_type: null,
                responder: null,
                response_date: null,
            },
            searchQuery: { pageNumber: 1, pageSize: 250, sort: null, colId: null },
            // Ag-Grid specific
            rowModelType: 'serverSide',
            columnDefs: null,
            gridApi: null,
            columnApi: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                onSelectionChanged: this.onSelectionChanged,
                rowSelection: 'multiple',
                isRowSelectable: (node) => {
                    const status = (node?.data?.status || '').toString().trim().toLowerCase()
                    return status !== 'completed'
                },
            },
        }
    },
    beforeMount() {
        this.columnDefs = Provider_Response_Headers.map((col, index) => {
            if (index === 0 && col.field === 'multichoice') {
                return { ...col, HeaderChangeCallback: this.headerChangeCallback, HeaderResetCallback: (fn) => { this._headerCheckboxReset = fn } }
            }
            return col
        })
    },
    created() {
        this.$emit('onReLoadCommunicationData')
        if (this.allow_paperresponse == false || this.status == 'CLOSED') {
            this.showaddmore = false
        } else {
            this.showaddmore = true
        }
        // Disable PR Response Template button if the status is closed
        if (this.status == 'CLOSED') {
            this.disableRecallPRTemplateBtn = true
        }
    },

    methods: {
        headerChangeCallback(checkedAll) {
            this.gridApi.forEachNode((node) => {
                const status = (node?.data?.status || '').toString().trim().toLowerCase()
                if (status === 'completed') {
                    node.setSelected(false)
                    return
                }
                node.setSelected(checkedAll)
            })
            this.updateSelectionButtons()
        },
        updateSelectionButtons() {
            const selectedRows = this.getSelectedRowsData()
            this.canUpdateResponseActions = selectedRows.length > 0
        },
        resetHeaderCheckbox() {
            if (this._headerCheckboxReset) {
                this._headerCheckboxReset()
            }
        },
        getSelectedRowsData() {
            const selectedRows = []
            this.gridApi.forEachNode((node) => {
                if (node.isSelected()) {
                    selectedRows.push({
                        paperResponseId: node.data.paper_response_id,
                        paperResponseLocationId: node.data.paper_response_location_id ?? null,
                        coveredStatus: node.data.covered_status ?? null,
                        oldResponseStatus: node.data.status ?? null,
                        providerOrgId: node.data.providerOrgId ?? null,
                        communicationAffectedLocationId: node.data.communication_affected_location_id ?? null,
                    })
                }
            })
            return selectedRows
        },
        async callProcessSelectedPaperResponsesAPI(updateType = null, updateValue = null) {
            const selectedRows = this.getSelectedRowsData()
            if (selectedRows.length === 0) {
                return
            }
            try {
                const response = await recallServices.processSelectedPaperResponses(
                    this.communicationId,
                    selectedRows,
                    updateType,
                    updateValue
                )
                if (!response.error) {
                    this._showToast('Provider responses processed successfully', { variant: 'success' })
                    this.selectedUpdateType = ''
                    this.selectedUpdateValue = ''
                    if (this.gridApi) {
                        this.gridApi.deselectAll()
                    }
                    this.canUpdateResponseActions = false
                    this.resetHeaderCheckbox()
                    this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                } else {
                    this._showToast('Error processing provider responses', { variant: 'danger' })
                }
            } catch (error) {
                this._showToast('Error processing provider responses', { variant: 'danger' })
            }
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length >= 1 || searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        },
        onFilterChanged(event) {
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.fetchData(event)
        },
        onSelectionChanged(event) {
            this.updateSelectionButtons()
        },
        onCellClicked(params) {
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'view') {
                    this.viewResponseRecall(params.data)
                }
                if (params.event.target.dataset.action === 'edit') {
                    if (params.data?.status === 'Completed') {
                        return
                    }
                    this.EditResponseRecall(params.data)
                }
                if (params.event.target.dataset.action === 'delete') {
                    this.deleteById(params.data)
                }
                return
            } else if (params.column.colId === 'files' && params?.data?.files && params?.data?.files?.length > 0) {
                for(let i=0; i < params.data.files.length; i++)
                {
                    if (params.event.target.dataset.action === 'viewclick_' + params.data.files[i]?.file_id) {
                        return this.ViewClick(params.data.files[i])
                    }
                }
            }else {
                this.viewResponseRecall(params.data)
            }
        },
        getLocations() {
            recallServices.getLocationForPaperResponse(this.communicationId).then((res) => {
                if (!res.error) {
                    if (res.data.d.length == 0 || this.status == 'CLOSED') {
                        this.disableRecallPRTemplateBtn = true
                    } else {
                        this.disableRecallPRTemplateBtn = false
                    }
                }
            })
        },
        onCompleted(type) {
            if (type == 'UPLOAD') {
                this._showToast('Successfully uploaded!')
            }
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        },
        importRecallPaperResponse() {
            this.paperResponseImportKey += 1
            this.$nextTick(() => {
                this.$refs.paperResponseImport.forceRerenderInsert()
            })
        },
        btnRecallPRTemplateBtnClick() {
            recallServices.downloadPaperResponseTemplate(this.communicationId, this.communicationUID)
        },
        addMoreClick() {
            this.paperModalKey += 1
            this.item = []
            this.item.communicationType = this.communicationType
            this.$nextTick(() => {
                this.$refs.paperModal.forceRerenderInsert(this.item)
            })
        },
        viewResponseRecall(item) {
            this.paperModalKey += 1
            item.communicationType = this.communicationType
            item.communicationUID = this.communicationUID
            this.$nextTick(() => {
                this.$refs.paperModal.forceRerenderView(item)
            })
        },
        EditResponseRecall(item) {
            this.paperModalKey += 1
            item.communicationType = this.communicationType
            item.communicationUID = this.communicationUID
            this.$nextTick(() => {
                this.$refs.paperModal.forceRerenderEdit(item)
            })
        },
        fetchDataOnSuccess(val) {
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            if (val != null && val != undefined && val != '') {
                this._showToast(val, { variant: 'success' })
            }
        },
        fetchData(params) {
            if (params && params.api) {
                this.gridApi = params.api
                this.columnApi = params.columnApi
            }
            this.getLocations()
            const that = this
            const datasource = {
                getRows(rowParams) {
                    that.searchQuery.colId = rowParams.request?.sortModel[0]?.colId
                    that.searchQuery.sort = rowParams.request?.sortModel[0]?.sort
                    that.search.filterModel = that.gridApi.getFilterModel()
                    recallServices.getSupplierPaperResponse({
                        ...that.searchQuery,
                        sortField: rowParams.request?.sortModel[0]?.colId,
                        sortDirection: rowParams.request?.sortModel[0]?.sort,
                        ...that.search,
                        globalSearchText: that.globalSearchText,
                    }, that.communicationId).then((resp) => {
                        that.total = resp.data.d.t
                        if (that.total == 0) that.gridApi.showNoRowsOverlay()
                        else that.gridApi.hideOverlay()
                        rowParams.successCallback(resp.data.d.c)
                    }).catch(() => {
                        rowParams.failCallback()
                    })
                },
            }
            if (this.gridApi) {
                this.gridApi.setServerSideDatasource(datasource)
            }
        },
        async download(dataurl) {
            this.ViewClick(dataurl)
        },
        ViewClick(val) {
            this.viewModalKey += 1
            this.$nextTick(() => {
                this.$refs.viewModal.forceRerenderInsert(val)
            })
        },
        deleteById(list) {
            this._showConfirm('Are you sure to delete the provider response, this cannot be undone?', { title: 'Delete Provider Response', variant: 'danger' }).then(confirm => {
                if (confirm) {
                    recallServices.deletePaperResponse(list.paper_response_id).then(resp => {
                        if (!resp.error) {
                            this.fetchDataOnSuccess('Provider Response deleted successfully')
                        }
                    })
                }
            })
        },
        openUpdateResponseTypeModal() {
            this.selectedUpdateType = 'paper_response_type'
            this.selectedUpdateValue = ''
            this.modalTitle = 'Update Response Type'
            this.modalOptions = PAPER_RESPONSE_TYPE
            this.modalRadioName = 'responseType'
            this.updateOptionModalKey += 1
            this.$nextTick(() => {
                this.$refs.updateOptionModal.forceRerender()
            })
        },
        openUpdateStatusModal() {
            this.selectedUpdateType = 'paper_response_status'
            this.selectedUpdateValue = ''
            this.modalTitle = 'Update Status'
            this.modalOptions = PAPER_RESPONSE_STATUS
            this.modalRadioName = 'responseStatus'
            this.modalSelectedRowStatuses = []
            this.gridApi.forEachNode((node) => {
                if (node.isSelected() && node.data && node.data.status) {
                    this.modalSelectedRowStatuses.push(node.data.status)
                }
            })
            this.updateOptionModalKey += 1
            this.$nextTick(() => {
                this.$refs.updateOptionModal.forceRerender()
            })
        },
        saveUpdateOption(selectedValue) {
            if (!selectedValue) {
                this._showToast('Please select an option', { variant: 'warning' })
                return
            }
            this.selectedUpdateValue = selectedValue
            this.callProcessSelectedPaperResponsesAPI(this.selectedUpdateType, this.selectedUpdateValue)
        },
    }
}